import { MapiranjeDeljivihPravic } from './DeljenePravice/MapiranjeDeljivihPravic'

export const DeljenjePravicPretvornik = {
  methods: {
    GetPretvorjenSeznamPravic (seznamPravic) {
      let permissionsList = []
      for (let i = 0; i < seznamPravic.length; i++) {
        if (seznamPravic[i].selector === null) {
          continue
        }
        let permissionObj = {}
        let permissionId = seznamPravic[i].permission
        let mappedValues = this.GetConfigByPermissionId(permissionId)
        permissionObj.permissionId = permissionId
        permissionObj.title = seznamPravic[i].title
        permissionObj.results = []
        if (permissionObj.title === null) {
          permissionObj.title = permissionId
        }
        permissionObj.description = seznamPravic[i].description
        permissionObj.placeholder = (mappedValues !== null) ? mappedValues.placeholder : 'Izberite'
        if (mappedValues !== null && mappedValues.dataFeed === 'selector') {
          for (let j = 0; j < seznamPravic[i].selector.length; j++) {
            let resultsObj = {}
            let value = seznamPravic[i].selector[j].id
            let label = seznamPravic[i].selector[j].naziv

            resultsObj = {
              selectorValue: value,
              selectorLabel: mappedValues.labelFeed === 'selector' ? label : value
            }
            permissionObj.results.push(resultsObj)
          }
        } else {
          for (let j = 0; j < seznamPravic[i].results.length; j++) {
            let resultsObj = {}
            let value = seznamPravic[i].results[j]
            let label = typeof seznamPravic[i].selector[j] !== 'undefined' ? seznamPravic[i].selector[j].naziv : ''
            resultsObj = {
              selectorValue: value,
              selectorLabel: mappedValues.labelFeed === 'selector' ? label : value
            }
            permissionObj.results.push(resultsObj)
          }
        }
        permissionsList.push(permissionObj)
      }
      return permissionsList
    },
    GetConfigByPermissionId (permissionId) {
      for (let i = 0; i < MapiranjeDeljivihPravic.length; i++) {
        if (MapiranjeDeljivihPravic[i].permissionId === permissionId) {
          return MapiranjeDeljivihPravic[i]
        }
      }
      return null
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/globalne_funkcije/Pravice/DeljenjePravicPretvornik.js